import AfiliadoPage from "./AfiliadoPage";
export default AfiliadoPage;